import { SnackbarOrigin } from "@mui/material";

export const AUTO_HIDE_DURATION = 4000;

export const SNACKBAR_ANCHOR: SnackbarOrigin = {
  vertical: "top",
  horizontal: "right"
};
